module.exports = __webpack_public_path__ + "static/media/trx.51271dac.svg";